import * as React from 'react';
import { getUsaStates } from 'client/fetch/states';
import { FieldSelect } from 'components/Forms/FieldSelect';
const StateSelect = ({ id, title, placeholder, name, className, required, onChange, }) => {
    const usaStates = getUsaStates();
    const options = usaStates.data || [];
    return (React.createElement(FieldSelect, { id: id, title: title, name: name, required: required, disabled: !usaStates.data, className: className || 'drop-box', onChange: onChange, placeholder: usaStates.isFetching ? 'Please wait...' : placeholder, options: options }));
};
export default StateSelect;
